module.exports = __webpack_public_path__ + "media/assets/icons/ic-star-circle-filled-dd259a32bffc91ec7e69041254ff8521.svg";